"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../utils");
/**
 * Adds allergens to order based on seatNumber if exist
 * @param event of type AssignOrderAllergensEvent
 * @param prevState
 */
function default_1(event, prevState = {}) {
    var _a, _b;
    const order = (0, utils_1.clone)(prevState);
    if (!(0, utils_1.isOrderEditable)(order.status)) {
        return order;
    }
    const seatNumber = String(event.seatNumber || '') || utils_1.ALL_ALLERGENS_KEY;
    if (!((_a = order.allergens) === null || _a === void 0 ? void 0 : _a[seatNumber])) {
        order.allergens = {
            ...order.allergens,
            [seatNumber]: [],
        };
    }
    order.allergens[seatNumber] = (_b = event.allergens) !== null && _b !== void 0 ? _b : [];
    return order;
}
exports.default = default_1;
//# sourceMappingURL=setOrderAllergens.js.map